import { GlobalState } from '../../../../types.global';
import { selectFeatureFlags } from '../../../../store/selectors';
import { Engines } from '../types';

export const selectSearchDiscovered = (state: GlobalState): boolean => {
  const { CUSTOM_SEARCH_ENGINE } = selectFeatureFlags(state);
  return CUSTOM_SEARCH_ENGINE ? state.search.isSearchDiscovered : true;
};

export const selectNtpSearchCount = (state: GlobalState): number =>
  state.search.ntpSearchCount;

export const selectIsAutofocus = (state: GlobalState): boolean => {
  if (
    process.env.APP_PLATFORM === 'web' &&
    process.env.NODE_ENV === 'production'
  ) {
    return true;
  }

  const { isAutofocus } = state.search;

  if (isAutofocus !== null) return isAutofocus;

  const { SEARCH_BOX_AUTOFOCUS_DEFAULT } = selectFeatureFlags(state);

  return typeof SEARCH_BOX_AUTOFOCUS_DEFAULT === 'undefined'
    ? null
    : SEARCH_BOX_AUTOFOCUS_DEFAULT;
};

export const selectDailyAdClickCount = (state: GlobalState): number =>
  state.search.dailyAdClicksCount;

export const selectIsFocus = (state: GlobalState): boolean =>
  state.search.isFocused;

export const selectIsChooseEngineOpened = (state: GlobalState): boolean =>
  state.search.isChooseEngineOpened;

export const selectCommand = (state: GlobalState): chrome.commands.Command =>
  state.search.command;

export const selectFetchedQuery = (state: GlobalState): string =>
  state.search.$organic?.term;

export const selectEngine = (state: GlobalState): Engines => {
  const { CUSTOM_SEARCH_ENGINE } = selectFeatureFlags(state);
  const { engine } = state.search;
  return engine || (CUSTOM_SEARCH_ENGINE ? null : 'oh');
};
